// src/pages/Clinic/ClinicJoinPage.jsx
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../axiosInstance';
import { toast } from 'react-toastify';
import { Box, Button, CircularProgress, Typography, Stack } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

export default function ClinicJoinPage() {
  const { token } = useParams();
  const { isAuthenticated } = useAuth(); // asume que tienes este flag
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      toast.error('Token inválido');
      navigate('/login');
      return;
    }
    if (!isAuthenticated) {
      localStorage.setItem('clinic_invite_token', token);
      toast.info('Inicia sesión para aceptar la invitación');
      navigate('/login');
    }
  }, [token, isAuthenticated, navigate]);

  const accept = async () => {
    try {
      setSubmitting(true);
      await axiosInstance.post('/clinics/join/', { token });
      toast.success('Invitación aceptada');
      navigate('/doctor/dashboard');
    } catch (e) {
      toast.error('No se pudo aceptar la invitación');
    } finally {
      setSubmitting(false);
    }
  };

  const decline = async () => {
    try {
      setSubmitting(true);
      await axiosInstance.post('/clinics/invitations/decline/', { token });
      toast.success('Invitación rechazada');
      navigate('/login');
    } catch (e) {
      toast.error('No se pudo rechazar la invitación');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Invitación a unirse a una clínica</Typography>
      <Typography sx={{ mb: 3 }}>¿Deseas aceptar la invitación?</Typography>
      <Stack direction="row" spacing={2}>
        <Button variant="contained" onClick={accept} disabled={submitting}>
          {submitting ? <CircularProgress size={20} /> : 'Aceptar'}
        </Button>
        <Button variant="outlined" color="error" onClick={decline} disabled={submitting}>
          Rechazar
        </Button>
      </Stack>
    </Box>
  );
}
